import { typedQueryClient, useTypedMutation } from "hooks";
import { useManufacturerDashboardFilters } from "modules/ManufacturerDashboard/hooks/useManufacturerDashboardFilters";
import { ManufacturerQueryKeys } from "modules/ManufacturerDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Pin } from "models";

//TODO: This is temporary workaround, create a ticket to properly support live update for manufacturer page,
//      cleanup the query keys, cleanup like it is done in other places
export const useAddManufacturerPinMutation = () => {
  const filters = useManufacturerDashboardFilters();

  return useTypedMutation({
    mutationFn: async (payload: Pin) => (await ApiInstance.post("/pins/append", payload)).data,
    onSuccess: () => typedQueryClient.invalidateQueries(ManufacturerQueryKeys.manufacturerListRequests(filters))
  });
};
